/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Confirm_Detail_InstructionsInputs */



/**
* | output |
* | --- |
* | "Instructions" |
*
* @param {Uno_Confirm_Detail_InstructionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_confirm_detail_instructions = /** @type {((inputs?: Uno_Confirm_Detail_InstructionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Confirm_Detail_InstructionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Anweisungen")
	return /** @type {LocalizedString} */ ("Instructions")
});